import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class OrderTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('OrderTypeReference');
  }
}
